export default class VehicleModelController {
  constructor(resource) {
    this._resource = resource;
  }

  async get() {
    return await this._resource(`vehicle_model`)
      .get()
      .then(res => res.body);
  }

  async getAllByListId(clients, vehicleCategory) {
    return await this._resource(`vehicle_model/getAllByListId`)
      .get({ clients: clients, vehicleCategory: vehicleCategory })
      .then(res => res.body);
  }

  async delete(id) {
    return await this._resource(`vehicle_model/${id}`)
      .delete(id)
      .then(res => res.body);
  }

  async update(model) {
    return await this._resource(`vehicle_model`)
      .update(model)
      .then(res => res.body);
  }

  async create(model) {
    return await this._resource(`vehicle_model`)
      .save(model)
      .then(res => res.body);
  }
}
